import React from "react";
import {Typography, Stack, Divider, Box, Button, Chip, Container} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faGavel,
    faLeaf,
    faExclamationTriangle,
    faUsers,
    faBullhorn,
    faInfoCircle,
    faCheckCircle,
    faHandPointRight,
    faShareAlt,
} from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "@others/title-section.layout";


const ARTICLE20250827: React.FC = () => {

    return(
        <>
            <Container maxWidth="lg" sx={{ mb: 6 }}>
                <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
                <Stack spacing={2}>
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                        <FontAwesomeIcon icon={faGavel} color="#F44336" size="lg" />
                        <Typography variant="h5" component="h2" color="primary" fontWeight={700}>
                            Le PLUi de la CAPF est-il attaquable&nbsp;?
                        </Typography>
                    </Stack>
                    <Typography align="center" variant="body1" fontWeight={500} color="text.secondary">
                        Strasbourg nous montre la voie&nbsp;!
                    </Typography>
                    <Box sx={{ bgcolor: "#e3f2fd", borderRadius: 2, px: 2, py: 1 }}>
                        <Typography variant="body2" fontWeight={600}>
                            En juillet 2025, le Tribunal Administratif de Strasbourg a annulé un PLUi pour&nbsp;:
                        </Typography>
                        <Stack spacing={0.5} component="ul" sx={{ pl: 2, pt: 0.5 }}>
                            <Stack component="li" direction="row" alignItems="center" spacing={1}>
                                <FontAwesomeIcon icon={faLeaf} color="#388e3c" />
                                <Typography variant="body2" component="span">
                                    Études environnementales insuffisantes
                                </Typography>
                            </Stack>
                            <Stack component="li" direction="row" alignItems="center" spacing={1}>
                                <FontAwesomeIcon icon={faExclamationTriangle} color="#FFA000" />
                                <Typography variant="body2" component="span">
                                    Mauvaise évaluation de la consommation foncière
                                </Typography>
                            </Stack>
                            <Stack component="li" direction="row" alignItems="center" spacing={1}>
                                <FontAwesomeIcon icon={faInfoCircle} color="#1565c0" />
                                <Typography variant="body2" component="span">
                                    Information incomplète du public
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>
                    <Typography fontWeight={600} sx={{ mt: 1 }}>
                        Ces arguments sont-ils transposables au PLUi de la CAPF&nbsp;?
                    </Typography>

                    <Typography>
                        Nous ne sommes pas juges, mais les similitudes sont frappantes&nbsp;:
                    </Typography>
                    <Stack component="ul" spacing={0.5} sx={{ pl: 2 }}>
                        <Stack component="li" direction="row" spacing={1} alignItems="start">
                            <FontAwesomeIcon icon={faLeaf} color="#81c784" style={{ marginTop: 5}} />
                            <Box>
                                <Typography component="span" fontWeight={500}>Environnement&nbsp;: cartographie des corridors écologiques bâclée, pas d’études sérieuses sur les zones humides, le Bois de la Source, ex clinique Chantemerle, etc.</Typography>
                            </Box>
                        </Stack>
                        <Stack component="li" direction="row" spacing={1} alignItems="start">
                            <FontAwesomeIcon icon={faGavel} color="#ffa726" style={{ marginTop: 5}} />
                            <Box>
                                <Typography component="span" fontWeight={500}>Stratégie foncière&nbsp;: aucune méthodologie claire pour les SMS&nbsp;; objectifs ZAN et SRU incohérents.</Typography>
                            </Box>
                        </Stack>
                        <Stack component="li" direction="row" spacing={1} alignItems="start">
                            <FontAwesomeIcon icon={faBullhorn} color="#29b6f6" style={{ marginTop: 5}} />
                            <Box>
                                <Typography component="span" fontWeight={500}>Information du public&nbsp;: PLUi découvert par les Bacots seulement deux semaines avant le vote du 1<sup>er</sup> arrêt, propriétaires des SMS non prévenus.</Typography>
                            </Box>
                        </Stack>
                        <Stack component="li" direction="row" spacing={1} alignItems="start">
                            <FontAwesomeIcon icon={faHandPointRight} color="#c62828" style={{ marginTop: 5}} />
                            <Box>
                                <Typography component="span" fontWeight={500}>+ Atteinte au droit de propriété, spécificité du PLUi de la CAPF voulue par le Maire de Bois-le-Roi</Typography>
                            </Box>
                        </Stack>
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="h6" fontWeight={600} align="center" color="text.primary">
                        Que faire&nbsp;? Deux options&nbsp;:
                    </Typography>
                    <Stack direction="row" spacing={2} justifyContent="center" sx={{ flexWrap: "wrap" }}>
                        <Chip
                            icon={<FontAwesomeIcon icon={faGavel} />}
                            label="1 – Recours au Tribunal Administratif de Melun"
                            sx={{ bgcolor: "#fff8e1", fontWeight: 500}}
                        />
                        <Chip
                            icon={<FontAwesomeIcon icon={faUsers} />}
                            label="2 – Miser sur les élections municipales"
                            sx={{ bgcolor: "#e8f5e9", fontWeight: 500 }}
                        />
                    </Stack>
                    <Stack spacing={1}>
                        <Box sx={{ pl: 2 }}>
                            <Typography fontWeight={700}>Recours au TA de Melun</Typography>
                            <ul>
                                <li><Typography>Délai : deux mois après la publication officielle</Typography></li>
                                <li>
                                    <b><Typography>Comment&nbsp;?</Typography></b>
                                    <ul>
                                        <li><Typography>S’appuyer sur le jugement de Strasbourg &amp; les contributions à l’enquête publique</Typography></li>
                                        <li><Typography>Mobiliser associations, riverains et communes voisines</Typography></li>
                                    </ul>
                                </li>
                            </ul>
                        </Box>
                        <Box sx={{ pl: 2 }}>
                            <Typography fontWeight={700}>Miser sur les municipales (« VLD2026 »)</Typography>
                            <ul>
                                <li><Typography>Si élus en mars 2026 :</Typography></li>
                                <ul>
                                    <li><Typography>Sursis à statuer pour bloquer les projets contestés</Typography></li>
                                    <li><Typography>Révision du PLUi (suppression des SMS, étude hydrogéologique, carte communale de l’eau &amp; la biodiversité)</Typography></li>
                                    <li><Typography>Protection renforcée</Typography></li>
                                </ul>
                            </ul>
                        </Box>
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                        <FontAwesomeIcon icon={faCheckCircle} color="#43a047" />
                        <Typography fontWeight={700} color="primary">
                            Avec #VLD2026, défendons une urbanisation maîtrisée, respectueuse de l’environnement et des habitants !
                        </Typography>
                    </Stack>
                    <Typography align="center" sx={{ fontStyle: "italic" }}>Vous êtes nombreux à dire que « trop, c’est trop ».</Typography>
                </Stack>
            </Container>
        </>
    )
}

export default ARTICLE20250827;